import i18n from "@/locale"
import { Toast } from "vant"
import { TEMPERATURE_CONVERT_MAP } from "@/utils/options"
import { convertTemp } from "@/utils/convert"
// import { projectCreate, projectDetails } from "@/api/projectPre"

export const convertTempStore = async ({ state, commit }, [target, source], datas = null) => {
  if (target == source) return
  const maps = [...TEMPERATURE_CONVERT_MAP]
  const traverseAndConvertTemp = data => {
    for (let key in data) {
      if (Array.isArray(data[key]) && maps.includes(key)) data[key] = data[key].map(val => convertTemp(val, target, source))
      else if (typeof data[key] === "object" && data[key] !== null) {
        traverseAndConvertTemp(data[key])
      } else if (maps.includes(key)) {
        data[key] = convertTemp(data[key], target, source)
      }
    }
  }
  const obj = datas ?? state.currentProject.pre
  traverseAndConvertTemp(obj)
  if (!!datas) commit("STORE_CURRENT_PROJECT", obj)
}

export const saveCurrentProject = ({ state, commit, dispatch, getters }) => {
  return new Promise(async (resolve, reject) => {
    dispatch("app/showLoading", i18n.t("index").msg.Saving, { root: true })

    try {
      const tempData = structuredClone(state.currentProject)
      await convertTempStore({ state, commit }, [1, getters.tempUnit.value], tempData)
      // const res = await projectCreate(tempData)
      await convertTempStore({ state, commit }, [getters.tempUnit.value, 1], res.data)
      Toast.success(i18n.t("index").msg.Success)
      resolve(res.data)
    } catch (err) {
      console.error(err)
      Toast.fail(i18n.t("index").msg.FailedRetry)
      reject(err)
    } finally {
      dispatch("app/clearLoading", null, { root: true })
    }
  })
}

export const fetchProjectDetails = ({ state, commit, dispatch, getters }, _id) => {
  return new Promise(async (resolve, reject) => {
    dispatch("app/showLoading", i18n.t("index").msg.Loading, { root: true })

    try {
      // const res = await projectDetails({ _id })
      commit("STORE_CURRENT_PROJECT", res.data)
      await convertTempStore({ state, commit }, [getters.tempUnit.value, 1])
      resolve(res.data)
    } catch (err) {
      console.error(err)
      Toast.fail(i18n.t("index").msg.FailedRetry)
      reject(err)
    } finally {
      dispatch("app/clearLoading", null, { root: true })
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/projectPre/actions.js